<template>
    <v-expansion-panels multiple>
        <v-expansion-panel>
            <v-expansion-panel-header>
                Field Tags
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <div class="MediaPanel__heading">
                    <v-btn
                        small
                        @click="selectAllFields"
                        color="primary"
                    >
                        All
                    </v-btn>
                    <span
                        v-if="fieldSelectButtons.length > 0"
                        class="FieldSelect__Buttons"
                    >
                        <v-btn
                            v-for="(field, index) in fieldSelectButtons"
                            :key="index+field"
                            small
                            @click="selectAllSimilarFields(field)"
                            color="secondary"
                        >
                            {{ field }}
                        </v-btn>
                    </span>
                    <v-btn
                        small
                        @click="clearFields"
                    >
                        Clear
                    </v-btn>
                </div>

                <ul
                    v-if="fieldsForSelect.length > 0"
                    class="FieldSelect__list"
                >
                    <li
                        v-for="(field, index) in fieldsForSelect"
                        class="FieldSelect__list__item"
                        :key="index+field.id"
                    >
                        <v-checkbox
                            :value="field.id"
                            v-model="selectedFields"
                            :key="index+field.id"
                        >
                            <template #label>
                                <span class="FieldLabel">
                                    <span class="FieldLabel__name">
                                        {{ field.name }}
                                    </span>
                                    <span class="FieldLabel__location">
                                        {{ field.group }}
                                    </span>
                                </span>
                            </template>
                        </v-checkbox>
                    </li>
                </ul>
            </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
            <v-expansion-panel-header>
                Specialty Tags
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <div class="MediaPanel__heading">
                    <v-btn
                        small
                        @click="selectAllProfessions"
                        color="primary"
                    >
                        All
                    </v-btn>
                    <v-btn
                        small
                        @click="clearProfessions"
                    >
                        Clear
                    </v-btn>
                </div>
                <ul
                    v-if="professions"
                    class="ProfessionSelect__list"
                >
                    <li
                        v-for="(prof, index) in professions"
                        :key="index+prof.id"
                        class="ProfessionSelect__list__item"
                    >
                        <v-checkbox
                            :value="prof.id"
                            :label="prof.name"
                            v-model="profession"
                        />
                    </li>
                </ul>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
import MediaCrudMixin from '@/views/Admin/MediaLibrary/MediaCrudMixin';

export default {
    mixins: [MediaCrudMixin]
};
</script>
